import React, { Component, PropTypes } from 'react';
import ImageUpload from 'common/components/image_upload';

/*
 * A modal that wraps the ImageUpload component.
 */

export default class ImageUploadModal extends Component {

  render() {
    const { show, toggleModal, tips } = this.props;

    if (!show) {
      return null;
    }

    return (
      <div className="modal-dialog image-upload-modal">
        <div className="modal-background" onClick={toggleModal}/>
        <div className={"modal-content-container" + (tips? " wide": "")}>
          <div className="modal-content">
            <div className="row">
              {tips &&
              <div className="columns small-16 medium-6">
                <aside className="sidebar">
                  <h4>Tips:</h4>
                  <ul>
                    { tips.map((tip, i) => <li key={i}>{ tip }</li>) }
                  </ul>
                </aside>
              </div>}

              <div className={"columns small-16 medium-" + (tips? "10":"16")}>
                <div className="form-upload-box">
                  <ImageUpload {...this.props} onDone={toggleModal}/>
                </div>
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-tertiary btn-block" onClick={toggleModal}>Done</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./common/components/modal/image_upload_modal.jsx